<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Помощники</strong>
                    <CLink to="/assistants/archive" class="float-right">Архив</CLink>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CompaniesTable :data.sync="list" :service="'assistants'" archivable @archived="fetch" />
                    </template>
                </CCardBody>

                <CCardFooter v-if="adminOnly">
                    <CButton
                        color="primary"
                        @click="$router.push('/assistants/create')"
                    >Создать</CButton>

                    <CButton
                        class="ml-4"
                        color="info"
                        @click="reorder"
                    >Сохранить расположение</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import CompaniesTable from '@/components/CompaniesTable'

    export default {
        name: 'AssistantList',

        components: {
            CompaniesTable,
        },

        data: () => ({
            loading: true,
            list: [],
        }),

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },

        async created() {
            await this.fetch();
            this.loading = false;
        },

        methods: {
            async fetch() {
                try {
                    const { data } = await this.axios.get('/assistants')
                    this.list = data
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка при получении списка помощников. ' + err);
                }
            },

            async reorder() {
                try {
                    const payload = {
                        reorder: this.list.map((item, idx) => ({ id: item.id, position: idx + 1, title: item.title }))
                    };
                    const { data } = await this.axios.post('/assistants/reorder', payload)
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка при сохранении порядка асситентов. ' + err);
                }
            }
        }
    }
</script>
